<template>
  <v-card :loading="!bookings">
    <v-card-title>
      {{ $t("admin.offers.title") }}

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('admin.users.search')"
        single-line
        hide-details
        color="secondary"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      v-if="bookings"
      :headers="headers"
      :items="bookings"
      :search="search"
      :no-results-text="$t('admin.users.noResults')"
      :items-per-page="-1"
      dense
      multi-sort
    >
      <template #item.actions="{ item }">
        <v-btn :to="{ name: 'adminUser', params: { id: item.user.id } }" icon small color="secondary">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template #item.funds="{ item }">
        {{ item.funds.length }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import BookingOffersQuery from "@/gql/queries/BookingOffers.gql";

export default {
  data() {
    return {
      search: "",
      bookings: null,
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("admin.users.auditPeriod"),
          value: "year",
          width: "25%",
        },
        {
          text: this.$t("admin.users.company"),
          value: "user.company.address.name",
          width: "50%",
        },
        {
          text: this.$t("admin.users.bookings"),
          value: "funds",
        },
        {
          text: "",
          value: "actions",
          filterable: false,
          sortable: false,
          align: "right",
          width: "1%",
        },
      ];
    },
  },

  apollo: {
    bookings: {
      query: BookingOffersQuery,
      fetchPolicy: "network-only",
    },
  },
};
</script>
